export * from './cart-total.component';
export * from './cart.component';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/components/cart/index.ts